import { gql } from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { AVATAR_REQUEST_KEY } from '~/modules/App/httpLink';
import { getEnvironment } from '~/modules/common/util';

export const avatarQueryPrefix = () =>
  ['staging', 'so1', 'so2', 'so3', 'sb1'].includes(getEnvironment() || '')
    ? AVATAR_REQUEST_KEY
    : '';

export const AVATAR_QUERY = gql`
  query ${avatarQueryPrefix()}GetAvatar($userUri: String!) {
    avatar(userId: $userUri) {
      id
      avatar
      medium
    }
  }
`;

const useAvatar = ({ userUri, size = 'avatar' }) => {
  const { data } = useQuery(AVATAR_QUERY, {
    variables: { userUri }
  });

  return data && data.avatar ? data.avatar[size] : null;
};

export default useAvatar;
